// extracted by mini-css-extract-plugin
export default {"root":"EditableTitle_root__fxJ0x","rootDisabled":"EditableTitle_rootDisabled__FWZuc","editIcon":"EditableTitle_editIcon__0BK-V","input":"EditableTitle_input__7QLmI"};